module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAQCAYAAADESFVDAAAArklEQVQoU+2RsQkCQRBF37gFKEYXihUIFiGogVrDwV4VulrEcQMXWIEaqGARgiUYXiRawLqieKJgaOhE8+AxfP4Iz1HVAbAsGRhaa1d3lr/0wwpUdQ60gCrQeGv8CFyAg6Rp2jTG7IHam1CuZ+99+5FJVXvA+ovUt9ZuXsGzLJuKyLgUQwizJEkmHw92zlWiKNqKSCeEsCuKouucu35Id8jzvO69XxhjRnEcn8qrN0SEX2BM/haCAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/image/reduce@2x.png
// module id = QBsY
// module chunks = 12